module.exports = __webpack_public_path__ + "img/LasstUnsLesenImBuchDerWeisheit.028b15ae.jpg";